<div class="container max-width">
  <div class="items mat-elevation-z4">
    @for (item of data?.contents; track item) {
      <div class="item">
        <p class="bold">{{ item.text }}</p>
        <a
          target="_blank"
          [download]="item.text"
          [href]="item.filePath">
          <mat-icon>cloud_download</mat-icon>
        </a>
      </div>
    }
    @if (data?.options?.folderPath) {
      <div>
        <div
          class="head"
          (click)="activeItems = !activeItems">
          <div>
            <mat-icon>folder</mat-icon>
            <p class="bold">{{ data?.folderTitle }}</p>
          </div>
          <mat-icon
            class="arrow"
            [class.rotate]="!activeItems">
            keyboard_arrow_up
          </mat-icon>
        </div>
        <div
          class="folder-items"
          [class.active]="activeItems">
          @for (item of keys; track item) {
            <div class="item">
              <p class="bold">{{ item }}</p>
              <button (click)="download(item)">
                <mat-icon>cloud_download</mat-icon>
              </button>
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
